<template>
  <div class="mobile-home">
    <!-- <MobileNavbarVue /> -->
    <section class="mobile-home-quick" aria-label="Raccourcis">
      <h2 class="mobile-home-quick-title">Modules</h2>
      <div class="mobile-home-grid">
        <router-link
          v-for="item in quickLinks"
          :key="item.name"
          :to="{ name: item.name }"
          class="mobile-home-card"
        >
          <i :class="item.icon"></i>
          <span>{{ item.label }}</span>
        </router-link>
      </div>
    </section>
  </div>
</template>

<script>
import MobileNavbarVue from "../../components/mobile/Navbar.vue";

export default {
  components: {
    MobileNavbarVue,
  },
  data() {
    return {
      quickLinks: [
        {
          name: "mobile-credits-index",
          label: "Crédits",
          icon: "bi bi-credit-card",
        },
        {
          name: "mobile-purchases-index",
          label: "Achats",
          icon: "bi bi-cart-dash",
        },
        {
          name: "mobile-payments-customers-index",
          label: "Paiements",
          icon: "bi bi-cash-stack",
        },
        {
          name: "mobile-sales-index",
          label: "Ventes",
          icon: "bi bi-bag-check",
        },
        {
          name: "mobile-stocks-index",
          label: "Stocks",
          icon: "bi bi-box-seam",
        },
      ],
    };
  },
};
</script>

<style scoped>
.mobile-home-quick {
  padding: 1rem 1.25rem 2rem;
  max-width: 720px;
  margin: 0 auto;
}

.mobile-home-quick-title {
  font-size: 1.25rem;
  font-weight: 700;
  margin: 0 0 1rem;
  color: #2d3748;
}

.mobile-home-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 0.75rem;
}

@media (min-width: 480px) {
  .mobile-home-grid {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
}

.mobile-home-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  padding: 1.25rem 0.75rem;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  text-decoration: none;
  color: #2d3748;
  font-weight: 600;
  font-size: 1.05rem;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(102, 126, 234, 0.2);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.mobile-home-card i {
  font-size: 2rem;
  color: #667eea;
}

.mobile-home-card:hover,
.mobile-home-card:focus-visible {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(102, 126, 234, 0.25);
  color: #667eea;
}

.router-link-active.mobile-home-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
  border-color: transparent;
}

.router-link-active.mobile-home-card i {
  color: #fff;
}
</style>
